import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";

const YagentRepository = repositoryFactory.get("yagent");

/**
 * 指定 site_id が yagent (PC用ツール) 対象媒体かを判定する。
 * @param {number|string} siteId
 * @returns {boolean}
 */
export function isYagentTargetSite(siteId) {
  return setting.yagent_target_site_ids.includes(Number(siteId));
}

// 未接続時の標準メッセージ（一箇所で管理）
const NOT_CONNECTED_MESSAGE =
  "PC用ツールが接続されていません。PC用ツールが起動中か確認してください。";

/**
 * yagent クライアントの疎通確認。
 * @param {number} shopSiteId
 * @param {object} [options]
 * @param {boolean} [options.silent=false]
 *   true なら未接続でも alert を出さず、呼び出し側に boolean だけを返す。
 *   キャスト更新・スケジュール更新等で内部的にエラー処理したい場合に使用。
 * @returns {Promise<boolean>} 接続中なら true、未接続なら false
 *   silent=false（デフォルト）の場合、未接続時は alert 表示済み
 */
export async function isYagentClientConnected(
  shopSiteId,
  { silent = false } = {}
) {
  const resp = await YagentRepository.admin_ping(shopSiteId);
  const delivered = resp.data.delivered;
  if (!delivered && !silent) {
    alert(NOT_CONNECTED_MESSAGE);
  }
  return delivered;
}
